'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components/Heading';

export interface H2Props extends HTMLAttributes<HTMLHeadingElement> {}

export default function H2({ children, ...props }: H2Props) {
    return (
        <Heading
            type="h2"
            size="5xl"
            {...props}
        >
            {children}
        </Heading>
    );
}
